import React from 'react';
import MessageContent from 'components/messages/MessageContent';
import Message from 'components/Message';

const NoNetworkMessage = ({ onDismiss }) => (
  <Message
    type="error"
    onDismiss={onDismiss}
    message={(
      <MessageContent>
        No network connection
      </MessageContent>
    )}
  />
);

NoNetworkMessage.displayName = 'NoNetworkMessage';

NoNetworkMessage.propTypes = {
  onDismiss: Message.propTypes.onDismiss.isRequired,
};

export default NoNetworkMessage;
